import {
  Adapter,
  Channel,
  Currency,
  IAdapter,
  IChannel,
  ICurrency,
  IServicepoint,
  IServicepointData,
  IServicepointDetail,
  IServicepointDetailData,
  ISubclient,
  Subclient,
  IThirdcode,
  Thirdcode,
  IProsegurPay,
  IServicepointServiceSyncResponse,
} from "@/entities";
import { SERVICEPOINT_TYPE } from "@/constans";
import { ILimit, Limit } from "@/entities/limit";
import { IUserServicepointApproval } from "../servicepoint_approval";

export class Servicepoint implements IServicepoint {
  readonly id?: number;
  readonly type?: SERVICEPOINT_TYPE;
  readonly oidSol?: string;
  readonly label?: string;
  readonly codeSol?: string;
  readonly idSmartcash?: string;
  readonly uniqueCode?: string;
  readonly deviceId?: string;
  readonly description?: string;
  readonly openChannel?: boolean;
  readonly accountDate?: boolean;
  readonly address?: string;
  readonly ssId?: string;
  readonly password?: string;
  readonly active?: boolean;
  readonly subclientId?: number;
  readonly subclient?: ISubclient;
  readonly thirdcodes?: IThirdcode[];
  readonly limits?: ILimit[];
  readonly agilePickup?: boolean;
  readonly econoCash?: boolean;
  readonly prosegurPay?: IProsegurPay;
  readonly enabledReadQr?: boolean;
  readonly enabledFlowApproval?: boolean;
  readonly userApprovals?: IUserServicepointApproval[];

  constructor(data: IServicepointData) {
    this.id = data.id;
    this.type = data.type;
    this.oidSol = data.oidSol;
    this.label = data.label;
    this.codeSol = data.codeSol;
    this.idSmartcash = data.idSmartcash;
    this.uniqueCode = data.uniqueCode;
    this.deviceId = data.deviceId;
    this.description = data.description;
    this.address = data.address;
    this.ssId = data.ssId;
    this.password = data.password;
    this.openChannel = data.openChannel;
    this.accountDate = data.accountDate;
    this.active = data.active;
    this.subclientId = data.subclientId;
    this.thirdcodes = data.thirdcodes?.map((thircode) => new Thirdcode(thircode));
    this.limits = data.limits?.map((limit) => new Limit(limit));
    this.agilePickup = data.agilePickup;
    this.econoCash = data.econoCash;
    this.prosegurPay = data.prosegurPay;
    this.enabledReadQr = data.enabledReadQr;
    this.enabledFlowApproval = data.enabledFlowApproval;
    this.userApprovals = data.userApprovals;

    if (data.subclient) {
      this.subclient = new Subclient(data.subclient);
    }
  }
}

export class ServicepointDetail extends Servicepoint implements IServicepointDetail {
  readonly adapters: IAdapter[];
  readonly channels: IChannel[];
  readonly currencies: ICurrency[];

  constructor(data: IServicepointDetailData) {
    super(data);

    this.adapters = data.adapters.map((adapter) => new Adapter(adapter));
    this.channels = data.channels.map((channel) => new Channel(channel));
    this.currencies = data.currencies.map((currency) => new Currency(currency));
  }
}

export class ServicepointServiceSyncResponse implements IServicepointServiceSyncResponse {
  success: boolean;
  data: IServicepointDetailData | null;
  message?: string;

  constructor(success: boolean, data: IServicepointDetailData | null, message?: string) {
    this.success = success;
    this.data = data;
    this.message = message;
  }
}
